<template>

 <div v-if="record !== undefined">
  <div v-if="record.StatusID === 1" class="inactivepast">
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24"><span class="formatDateDayNr">{{record.DayNr}}</span></div>
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24" @click="dateSelected"><span class="formatDateDayName">{{record.DayName}}</span></div>
  </div>
  <div v-else :style="buttonStyles">
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24" @click="dateSelected"><span class="formatDateDayNr">{{record.DayNr}}</span></div>
    <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24" @click="dateSelected"><span class="formatDateDayName">{{record.DayName}}</span></div>
  </div>
  </div>
</template>

<style>
.formatDateDayName {
  text-align: center;
  width: 29px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.formatDateDayNr {
    text-align: center;
    display: inline-block;
    vertical-align: middle;
    -webkit-transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
    cursor: pointer;
    font-weight: 700;
    font-size: 18px;
    width: 29px;
    text-align: center;
}
.inactivepast
{
  color:#ffffff;
  background: repeating-linear-gradient(
  135deg,
  #111 ,
  #fff 4px,
  #111 4px,
  #111 4px
  );
}
</style>

<script>
  import Vue from 'vue';

  export default {
    props: ['record'],
    data () {
      return {
         
      }
    },
    methods: {
      dateSelected (id) {
          this.record.IsSelected = true;
          this.$emit('dat-select-event', this.record);
      }
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
      buttonStyles(){
        return {
            "backgroundColor" : this.record.IsSelected ? "#eee"  : "#fff",
            "border-radius": '5px',
            "border-width": '1px'
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/CartDateItem.vue